// extracted by mini-css-extract-plugin
module.exports =  {"formWell":"V5Ol488RiI6_zBSNBzvw","preview":"TQaLoXztaYQe_aAZwync","previewAmount":"tzNLuN93PwNHF6XfyVD3"};